import {useEffect} from "react";
import {useForm, Controller} from "react-hook-form";
import {ModalForm} from "~/components";
import {SelectField} from "~/components/Forms";

const OFF_OPTION = {value: 'off', label: 'Tắt (không tự crawl)'};
const FREQ_LABEL = {daily: 'Hằng ngày', weekly: 'Hằng tuần', monthly: 'Hằng tháng'};

/**
 * Modal cấu hình crawl định kỳ của dự án. Chỉ chọn TẦN SUẤT; lần tự crawl kế thừa cấu
 * hình (max_depth/max_pages/...) của lần crawl gần nhất. Dùng ModalForm + Form chuẩn.
 * `options` = danh sách tần suất gói cho phép (từ BE); chỉ hiện các lựa chọn hợp lệ.
 */
function CrawlScheduleForm({open, submitting, current, options = [], onCancel, onSubmit}) {

	const selectOptions = [
		OFF_OPTION,
		...options.map((v) => ({value: v, label: FREQ_LABEL[v] || v})),
	];

	const {control, handleSubmit, reset} = useForm({
		defaultValues: {schedule: current || 'off'},
	});

	useEffect(() => {
		if (open) reset({schedule: current || 'off'});
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [open]);

	return (
		<ModalForm
			open={open}
			icon="fa-light fa-calendar-clock"
			title="Lịch crawl tự động"
			subtitle="Tự động chạy Site Crawler theo chu kỳ, kế thừa cấu hình lần gần nhất"
			onCancel={onCancel}
			onOk={handleSubmit((v) => onSubmit(v.schedule))}
			okText="Lưu lịch"
			loading={submitting}
		>
			<Controller control={control} name="schedule" render={({field}) => (
				<SelectField
					label="Tần suất tự crawl"
					options={selectOptions}
					style={{width: '100%'}}
					{...field}
				/>
			)} />
			<p style={{fontSize: 13, color: '#6b7280', marginTop: 4}}>
				Lịch chạy nền theo cronjob của hệ thống. Nếu gói giới hạn tần suất crawl, lần tự
				crawl sẽ tự lùi tới khi đủ khoảng cách cho phép. Bạn sẽ nhận thông báo khi crawl xong.
			</p>
		</ModalForm>
	);
}

export default CrawlScheduleForm;
